import {differenceInCalendarDays} from 'date-fns';
import {get} from 'lodash';

import {
  SLOTS_PER_BONUS,
  TOTAL_BONUSES,
  TOTAL_SLOTS,
} from '../constants/EligibleAcceleratorBonus.constants';
import {EligibleAcceleratorRecordData} from '../types/EligibleAcceleratorBonus.types';

export const getCappedOrderingEntities = (count: number): number =>
  Math.max(0, Math.min(count, TOTAL_SLOTS));

export const getCurrentDate = (
  recordData: EligibleAcceleratorRecordData = {},
): string =>
  get(recordData, 'currentDate', '') ||
  get(recordData, 'eligibilityStartDate', '') ||
  get(recordData, 'eligibleStartDate', '');

export const getEligibleThroughDate = (
  recordData: EligibleAcceleratorRecordData = {},
): string =>
  get(recordData, 'eligibleThrough', '') ||
  get(recordData, 'eligibleAccelThrough', '') ||
  get(recordData, 'eligibilityEndDate', '');

export const parseDateSafe = (dateValue: string): Date | null => {
  if (!dateValue) return null;
  const date = new Date(dateValue);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getCompletedBonuses = (cappedOrderingEntities: number): number =>
  Math.min(Math.floor(cappedOrderingEntities / SLOTS_PER_BONUS), TOTAL_BONUSES);

export const getGlobalProgressPercent = (completedBonuses: number): number =>
  (completedBonuses / TOTAL_BONUSES) * 100;

export const getDaysLeft = (
  currentDateObj: Date | null,
  eligibleThroughObj: Date | null,
): number =>
  currentDateObj && eligibleThroughObj
    ? Math.max(differenceInCalendarDays(eligibleThroughObj, currentDateObj), 0)
    : 0;

export const getFilledInTier = (
  cappedOrderingEntities: number,
  startSlot: number,
): number =>
  Math.max(
    0,
    Math.min(cappedOrderingEntities - (startSlot - 1), SLOTS_PER_BONUS),
  );

export const getTierSlotNumbers = (startSlot: number): number[] =>
  [0, 1, 2, 3, 4].map(index => startSlot + index);
